import { baseApi } from '../baseApi';

export const BrandApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoctypeDetails: builder.query({
      query: (params) => ({
        url: `/api/method/frappe.client.get`,
        params: params
      })
    }),
    PostBrand: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Brand`,
        method: 'post',
        body: data,
      }),
      invalidatesTags: ['Brand']
    }),
    getBrands: builder.query({
      query: ({ start = 0, limit = 12, filters = [] }) => {
        const fields = [
          "`tabBrand`.`name`",
          "`tabBrand`.`owner`",
          "`tabBrand`.`creation`",
          "`tabBrand`.`modified`",
          "`tabBrand`.`modified_by`",
          "`tabBrand`.`_user_tags`",
          "`tabBrand`.`_comments`",
          "`tabBrand`.`_assign`",
          "`tabBrand`.`_liked_by`",
          "`tabBrand`.`docstatus`",
          "`tabBrand`.`idx`",
          "`tabBrand`.`description`",
          "`tabBrand`.`image`"
        ];
        const params = {
          fields: JSON.stringify(fields),
          order_by: "`tabBrand`.`modified` desc",
          limit_start: start,
          limit_page_length: limit
        };

        if (filters.length > 0) {
          params.filters = JSON.stringify(filters);
        }

        return {
          url: `/api/resource/Brand`,
          method: 'GET',
          params,
        };
      },
      providesTags: ['Brand']
    }),
    getBrandByName: builder.query({
      query: (brandName) => ({
        url: `/api/resource/Brand/${brandName}`,
      }),
      providesTags: ['Brand']

    }),
    updateBrand: builder.mutation({
      query: ({ brandName, data }) => ({
        url: `/api/resource/Brand/${brandName}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Brand']
    }),
    getBrandCount: builder.query({
      query: () => ({
        url: `/api/method/frappe.desk.reportview.get_count`,
        params: {
          doctype: 'Brand'
        },
      }),
    }),

  }),
});

export const { useGetBrandCountQuery, useUpdateBrandMutation, useGetBrandByNameQuery, useGetBrandsQuery, usePostBrandMutation } = BrandApi;
